import { toastr } from "react-redux-toastr";

export function noNetworkMsg(){
    toastr.error("No Internet Connection", "Please try again");
};
export function exErrMsg(){
    toastr.error("An Error occured", "Please try again");
};
export function successMsg(msg, submsg){
    toastr.success(msg, submsg);
}
export function errorMsg(msg, submsg){
    toastr.error(msg, submsg);
}
export function clearMsg(){
    toastr.clean();
}
export function infoMsg(msg){
    toastr.info(msg);
}